'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: fixed;\n    left: -9999px;\n    top: -9999px;\n    &:checked ~ {\n      .hui-radioDisplay {\n        &:after {\n          opacity: 1;\n        }\n      }\n    }\n    &:focus ~ {\n      .hui-radioDisplay {\n        outline: none;\n        border-color: #2fb699;\n        box-shadow: 0 0 10px #2fb699;\n      }\n    }\n'], ['\n  position: fixed;\n    left: -9999px;\n    top: -9999px;\n    &:checked ~ {\n      .hui-radioDisplay {\n        &:after {\n          opacity: 1;\n        }\n      }\n    }\n    &:focus ~ {\n      .hui-radioDisplay {\n        outline: none;\n        border-color: #2fb699;\n        box-shadow: 0 0 10px #2fb699;\n      }\n    }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  cursor: pointer;\n  display: inline-block;\n  font-weight: 500;\n  font: 500 16px/18px;\n  color: #4a5b64;\n  margin: 0 0 0 16px;\n  max-width: calc(100% - 46px);\n  vertical-align: top;\n'], ['\n  cursor: pointer;\n  display: inline-block;\n  font-weight: 500;\n  font: 500 16px/18px;\n  color: #4a5b64;\n  margin: 0 0 0 16px;\n  max-width: calc(100% - 46px);\n  vertical-align: top;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  cursor: pointer;\n  border-radius: 50%;\n  border: 1px solid #b9c5cd;\n  width: 18px;\n  height: 18px;\n  display: inline-block;\n  position: relative;\n  background: #fff;\n  font-size: 0;\n  line-height: 0;\n  vertical-align: top;\n  &:after {\n    position: absolute;\n    left: 2px;\n    top: 2px;\n    right: 2px;\n    bottom: 2px;\n    border-radius: 50%;\n    background: #2eae8f;\n    content: " ";\n    opacity: 0;\n    z-index: 2;\n    transition: all .1s ease-in-out;\n  }\n'], ['\n  cursor: pointer;\n  border-radius: 50%;\n  border: 1px solid #b9c5cd;\n  width: 18px;\n  height: 18px;\n  display: inline-block;\n  position: relative;\n  background: #fff;\n  font-size: 0;\n  line-height: 0;\n  vertical-align: top;\n  &:after {\n    position: absolute;\n    left: 2px;\n    top: 2px;\n    right: 2px;\n    bottom: 2px;\n    border-radius: 50%;\n    background: #2eae8f;\n    content: " ";\n    opacity: 0;\n    z-index: 2;\n    transition: all .1s ease-in-out;\n  }\n']);

exports.radioId = radioId;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _text = require('@hixme-ui/text');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioInput = _styledComponents2.default.input(_templateObject);

var RadioText = _text.LabelBase.extend(_templateObject2);

var RadioDisplay = _styledComponents2.default.span(_templateObject3);
function radioId(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === undefined ? 'n' : _ref$name,
      _ref$text = _ref.text,
      text = _ref$text === undefined ? 't' : _ref$text,
      _ref$value = _ref.value,
      value = _ref$value === undefined ? 'v' : _ref$value;

  return 'hui:rb-' + name.toString() + '-' + text.toString() + '-' + value.toString();
}

var getRootProps = function getRootProps(props) {
  return ['style'].filter(function (p) {
    return props[p];
  }).reduce(function (memo, key) {
    return (0, _extends4.default)({}, memo, (0, _defineProperty3.default)({}, key, props[key]));
  }, {});
};

var RadioButton = function RadioButton(props) {
  var text = props.text,
      name = props.name,
      restProps = (0, _objectWithoutProperties3.default)(props, ['text', 'name']);


  return _react2.default.createElement(
    'label',
    (0, _extends4.default)({ htmlFor: radioId(props) }, getRootProps(props)),
    _react2.default.createElement(RadioInput, (0, _extends4.default)({ name: props.name, type: 'radio' }, restProps, { id: radioId(props) })),
    _react2.default.createElement(RadioDisplay, { className: 'hui-radioDisplay' }),
    props.text && _react2.default.createElement(
      RadioText,
      { htmlFor: radioId(props) },
      text
    )
  );
};

RadioButton.propTypes = {
  name: _propTypes2.default.string.isRequired,
  text: _propTypes2.default.string.isRequired
};

exports.default = RadioButton;
//# sourceMappingURL=RadioButton.js.map


//////////////////
// WEBPACK FOOTER
// ../radio-button/lib/RadioButton.js
// module id = 706
// module chunks = 0